module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dialogs/dialogs.component.css
// module id = ./src/app/components/dialogs/dialogs.component.css
// module chunks = main